module.exports = __webpack_public_path__ + "img/logo.eed33a3.png";